import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowSwitchBlockConfigSchema = z.object({
    fn: z.string().min(1, {
        message: 'Script is required.',
    }),
    switchResultType: z.string(),
});
export const FlowSwitchBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Switch),
    config: FlowSwitchBlockConfigSchema,
});
//# sourceMappingURL=config.js.map